import {
  Box,
  CloseButton,
  DrawerBody,
  DrawerHeader,
  DrawerFooter,
  Heading,
  Button,
  ButtonProps,
  Skeleton,
  Flex,
} from "@chakra-ui/react";
import ArchivedBadge from "components/Products/ArchivedBadge";

type SaveButtonProps = ButtonProps & {
  children?: React.ReactNode;
};

export function SaveButton({ children = "Save", ...rest }: SaveButtonProps) {
  return (
    <Button
      type="submit"
      colorScheme="pinkButton"
      loadingText="Saving…"
      {...rest}
    >
      {children}
    </Button>
  );
}

type Props = {
  children?: React.ReactNode;
  description?: string;
  footerContent?: React.ReactNode;
  heading?: string | null;
  headingPlaceholder?: string;
  isArchived?: boolean;
  isLoading?: boolean;
  onClose: () => void;
};

export default function EditPanelContent({
  children,
  description = "Edit",
  footerContent,
  heading,
  headingPlaceholder,
  isArchived,
  isLoading = false,
  onClose,
}: Props) {
  return (
    <Box display="flex" flexFlow="column" h="100%">
      <DrawerHeader display="flex" alignItems="flex-start" pr={3}>
        <Box flex="0 1 100%" minW="10rem">
          <Skeleton isLoaded={!!description || !isLoading} minW="5em" mb={1}>
            <Box fontSize="sm" fontWeight={300} color="gray.600">
              {description ?? " "}
            </Box>
          </Skeleton>
          <Skeleton isLoaded={!!heading || !isLoading} minW="10em">
            <Flex alignItems="baseline" gap={4}>
              <Heading
                size="lg"
                color="magenta.veryDark"
                opacity={!heading && !!headingPlaceholder ? 0.25 : undefined}
                isTruncated
                lineHeight="normal"
                mt="-.25em"
              >
                {heading ?? headingPlaceholder ?? " "}
              </Heading>
              {isArchived && <ArchivedBadge />}
            </Flex>
          </Skeleton>
        </Box>
        <CloseButton onClick={onClose} ml="auto" />
      </DrawerHeader>
      <DrawerBody>{children}</DrawerBody>
      <DrawerFooter gap={4}>{footerContent}</DrawerFooter>
    </Box>
  );
}
